<template>
 
        <v-layout class="mt-3 px-8">
          <v-form v-model="valid" ref="form">
            <v-text-field
                    v-model="novoNome"
                    :rules="nomeRules"
                    :type="'text'"
                    name="input-10-1"
                    label="Novo nome"
                    counter
                    @click:append="show1 = !show1"
              ></v-text-field>

            <v-checkbox
              label="Você Concorda?"
              v-model="checkbox"
              :rules="[(v) => !!v || 'Você deve concordar para alterar!']"
              required
            ></v-checkbox>
            <v-alert
              :value="erroEditar"
              color="error"
              icon="warning"
              outlined
            >
              Erro ao alterar o nome !!
            </v-alert>

            <v-alert
              :value="sucessoEditar"
              color="success"
              icon="check_circle"
              outlined
            >
              Sucesso ao alterar o nome !!
            </v-alert>
            <v-card-actions>
              <v-spacer/>
              <v-btn dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
              <v-btn @click="$router.go(-1)">      
                <v-icon left>keyboard_backspace</v-icon>
                    voltar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-layout>

</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'editarNomeAdministador',
  data () {
    return {
      senhaAtual: '',
      erroEditar: false,
      sucessoEditar: false,
      erroAlterarNome: 'false',
      tipo: 5,
      novoNome: '',
      show1: false,
      show2: false,
      valid: false,
      name: 'Default',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
      ],
      nomeRules: [
        (v) => v && v.length > 5 || 'Nome deve ter mais de 6 caracteres'
      ],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        console.log('form editar adm..')
        console.log(this.user)
        this.erroEditar = false
        this.sucessoEditar = false

        administradorUnidadeService.administradorUnidade
          .alterarNomeAdministradorUnidade(this.novoNome, this.user.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data.msg)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data == true) {
            this.$store
            .dispatch("SetUserName", this.novoNome)
              this.sucessoEditar = true
              this.clear()
            }
          
          })
          .catch(err => {
            this.erroEditar = true
            // handle your error here
            console.log(err)
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.novoNome = this.$store.getters.usuario.nome
  }

}

</script>
